<template>
  <div class="Tables">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-card-title class="title">
              Cuotas por Actividad Principal
              <v-spacer/>
              <v-card-actions v-if="dataValsMuestra.length > 0">
                <v-btn color="info" :disabled="dataValsMuestra.length < 1">
                  <download-csv
                    :data="dataValsMuestra"
                    :name="'Cuotas por Actividad Principal.csv'"
                    :labels="labelsMuestra"
                    :fields="fieldsMuestra"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadMuestra"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-if="dataValsMuestra.length > 0">
              <data-table
                :headers="headersMuestra"
                :dataVals="dataValsMuestra"
                :searchActive="true"
                :key="tableMuestraKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

import dataTable from '@/components/Tables/TableWithTotals'
import JsonCSV from 'vue-json-csv'

export default {
  name: `Tables`,

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.processMuestra()
  },

  data: function () {
    return {
      backConf: {
        path: '/charts/avancegeneral',
        pathMuestra: '/charts/muestra/',
        page: 1
      },
      operativo: null,

      loading: false,
      progressSize: 70,
      progressWidth: 7,

      headersMuestra: [],
      dataValsMuestra: [],
      labelsMuestra: {},
      fieldsMuestra: [],
      tableMuestraKey: 0,
      loadMuestra: false
    }
  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    }
  },

  computed: {},

  methods: {
    /**
     * Procesa los datos para la tabla cobertura agregando los datos faltantes de la tabla
     */
    processMuestra () {
      this.loadMuestra = true
      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathMuestra
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          // obtiene las keys para values, retirando los de meta y conteo
          let vals = Object.keys(resp.data[0])
          vals.splice(vals.length - 2)

          // calcualr el porcentaje y formatea los datos
          resp.data.forEach(function (element) {
            let perc = element.conteo / element.meta * 100
            perc = Number.parseFloat(perc).toFixed(1)

            let obj = {
              meta: element.meta,
              conteo: element.conteo,
              porcentaje: perc === 'NaN' ? Number.parseFloat(0).toFixed(1) : perc
            }
            // agrega las keys y los valores de los values, para mostrar
            vals.forEach(function (key) {
              obj[key] = element[key]
            })

            t.dataValsMuestra.push(obj)
          })

          t.tableConfig(vals)

          t.tableMuestraKey += 1
          t.loadMuestra = false
        })
        .catch(function (err) {
          t.dataValsMuestra = []
          t.loadMuestra = false
          console.error(err)
        })
    },

    /**
     * Confogura valores necesarios para el funcioanimiento de la tabla,
     * headers, labels y fields
     * @param  {array}   values Lista de valores a agregar
     */
    tableConfig (values) {
      let head = []

      values.forEach(function (key) {
        let obj = {
          text: key,
          align: 'left',
          value: key,
          str: ' '
        }
        head.push(obj)
      })

      head[head.length - 1].str = 'Totales'

      this.headersMuestra = head.concat([
        { text: 'Muestra', value: 'meta', align: 'right' },
        { text: 'Conteo', value: 'conteo', align: 'right' },
        { text: 'Avance %', value: 'porcentaje', align: 'right', str: ' ' }
      ])

      // Agrega los Labels para el CSV
      let obj = {}

      values.forEach(function (key) {
        obj[key] = key
      })

      this.labelsMuestra = Object.assign(obj, {
        meta: 'Muestra',
        conteo: 'Conteo',
        porcentaje: 'Avance'
      })

      // Agrega los Fields para el CSV
      this.fieldsMuestra = values.concat(['meta', 'conteo', 'porcentaje'])
    }
  }
}
</script>
